export const aspectRatioToPaddingBottomPercentage = (ratio = '4:3'): number => {
  try {
    const [width, height] = ratio.split(':');
    return parseInt(height) / parseInt(width);
  } catch (e) {
    return 1;
  }
};
